import './neon.scss';

export default({bigwin}) => {
    return (
        bigwin 
        ? <h1 className="neon" data-text="U">$ W<span className="flicker-slow">I</span>N<span className="flicker-fast">&nbsp;&nbsp;B</span>IG $</h1>
        : <h1 className="neon" data-text="U">W<span className="flicker-slow">I</span>NA<span className="flicker-fast">C</span>OIN</h1>
    )
}